const TIMEZONE_SUFFIX = /(Z|[+-]\d{2}:?\d{2})$/i;

export const formatBeijingDateTime = (value?: string | null): string => {
  if (!value) return '-';

  const normalized = value.trim().replace(' ', 'T');
  const source = TIMEZONE_SUFFIX.test(normalized) ? normalized : `${normalized}Z`;
  const date = new Date(source);
  if (Number.isNaN(date.getTime())) return value;

  const parts = new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((item) => item.type === type)?.value || '';

  return `${part('year')}/${part('month')}/${part('day')} ${part('hour')}:${part('minute')}:${part('second')}`;
};
